import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import useHistory from '../../hooks/useHistory';
import LendAPIFullAppFunnel from '../LendAPIFullApp';
import LendAPICombinedFunnel from '../../prequal/LendAPICombinedFunnel';
import PreQualLandingRoute from '../../prequal/PreQualLandingRoute';
import PageNotFound from '../components/PageNotFound';
import { normalizeProductType, validateProductType } from '../../utils/lendAPIRouteValidation';
import { isPrequalPath } from '../../utils/prequalRouteHelper';

const LendAPIRoutes: React.FC = () => {
  const history = useHistory();

  // The Pre-Qual landing page is served under a partner's own basePath-prefixed
  // URL (see isPrequalPath), so it can't rely on react-router's basename-relative
  // exact path matching — match on the raw pathname instead.
  if (isPrequalPath(history.location.pathname)) {
    return (
      <Router history={history}>
        <PreQualLandingRoute />
      </Router>
    );
  }

  return (
    <Router history={history}>
      <Switch>
        <Route path="/loan-application/:productType/:productId/:productSlug/" exact>
          {(props: any) => {
            const urlProductType = props.match.params.productType;
            const normalizedProductType = normalizeProductType(urlProductType);

            if (!validateProductType(normalizedProductType)) {
              console.error(
                `[LendAPI Routes] Invalid productType: ${urlProductType} (normalized: ${normalizedProductType})`
              );
              return <PageNotFound showLogin={false} />;
            }

            if (normalizedProductType === 'fullApp') {
              return <LendAPIFullAppFunnel />;
            }
            if (normalizedProductType === 'combined') {
              return <LendAPICombinedFunnel />;
            }

            return <PageNotFound showLogin={false} />;
          }}
        </Route>
        <Route path="*">
          <PageNotFound showLogin={false} />
        </Route>
      </Switch>
    </Router>
  );
};

export default LendAPIRoutes;
